/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-09-14 14:41:30
 * @LastEditors: linxi
 * @LastEditTime: 2021-09-14 20:15:05
 */
/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-09-14 14:17:30
 * @LastEditors: linxi
 * @LastEditTime: 2021-09-14 14:28:05
 */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { LoadingState } from "../../models/common";
import { Registration } from "../../models/registration";
import { Treatment } from "../../models/treatment";

interface OralCaseState {
  registration?: Registration;
  treatment?: Treatment;
  creatingState: LoadingState;
}

const initialState = {
  registration: undefined,
  creatingState: LoadingState.Idle,
} as OralCaseState;

const treatmentRegistSlice = createSlice({
  name: "oralCase",
  initialState,
  reducers: {
    setTreatmentRegistration: (state, action: PayloadAction<Registration>) => {
      state.registration = action.payload;
    },
    reSetRegistration: (state, action) => {
      state.registration = undefined;
    },
  },
});

export const {
  setTreatmentRegistration,
  reSetRegistration,
} = treatmentRegistSlice.actions;

export const treatmentRegistration = (
  state: RootState
): Registration | undefined => state.treatmentRegist.registration;

export default treatmentRegistSlice.reducer;
